module.exports = __webpack_public_path__ + "static/media/removeIcon.cdec5b26.svg";